import { SubAPI } from "./SubAPI";
export class QuoteMiscPricing extends SubAPI {
    list(props) { return this.fetcher.get("/api/quote-misc-prices", props); }
    upsert(props) { return this.fetcher.post("/api/quote-misc-price", props); }
    reOrder(props) { return this.fetcher.post("/api/quote-misc-price/reorder", props); }
    upsertPreset(props) { return this.fetcher.post("/api/quote-misc-price/preset", props); }
    listPresets(props) { return this.fetcher.get("/api/quote-misc-price/presets", props); }
}
